<template>
  <div class="pay">
    <h5>付款前，請再次檢查訂單及送貨資料</h5>
    <h4>然後，請選擇適合你的付款方法：</h4>
    <div class="select" @click="pay">
      <div>
        <div class="box">
          <h4>信用卡</h4>
          <img
            class="m-2"
            src="https://cdn.reubird.hk/general/application/visa.svg"
            alt="visa"
            height="25"
          />
          <img
            class="m-2"
            src="https://cdn.reubird.hk/general/application/mastercard.svg"
            alt="mastercard"
            height="25"
          />
          <img
            class="m-2"
            src="https://cdn.reubird.hk/general/application/american-express.svg"
            alt="american express"
            height="25"
          />
        </div>
        <h6>接受 Visa, Master Card, American Express</h6>
      </div>
      <div class="el-icon-arrow-right"></div>
    </div>
    <div class="select">
      <div>
        <div class="box">
          <h4>PayMe</h4>
          <img
            class="m-2"
            src="https://cdn.reubird.hk/general/application/payme-logo-red.png"
            alt="PayMe"
            height="17"
          />
        </div>
        <h6>接受 HSBC PayMe 付款</h6>
      </div>
      <div class="el-icon-arrow-right"></div>
    </div>
    <div class="select">
      <div>
        <div class="box">
          <h4>FPS 轉數快</h4>
          <img
            class="m-2"
            src="https://cdn.reubird.hk/general/application/fps.png"
            alt="fps"
            height="25"
          />
        </div>
        <h6>接受所有銀行的 FPS 轉數快 付款</h6>
      </div>
      <div class="el-icon-arrow-right"></div>
    </div>
    <div class="select">
      <div>
        <div class="box">
          <h4>銀行 / ATM 過數</h4>
        </div>
      </div>
      <div class="el-icon-arrow-right"></div>
    </div>
  </div>
</template>
<script>
import { addOrder } from "@/gql/order/mutation.gql";
export default {
  props: ["form", "meal", "additional"],
  data() {
    return {
      add: {
        orderTime: new Date(),
        username: this.form.name,
        customerName: this.form.name,
        customerPhone: this.form.phone,
        customerRemarks: this.form.claim,
        deliveryAddress: this.form.deliveryAddress,
        payAmount: this.form.orderAomunt,
      },
    };
  },
  methods: {
    pay() {
      let orderPrice =
        this.meal.price * (this.meal.count || 1) +
          (this.form.area
            ? parseInt(this.form.area.split("[")[1].split("]")[0].split("$")[1])
            : 0) +
          this.additional.tableware * this.additional.tablewarePrice +
          this.additional.clamp * this.additional.clampPrice || this.meal.price;
      this.$set(this.form, "orderAmount", orderPrice);
      // console.log(this.form);
      // console.log(this.meal)

      let orderDetails = [];
      let {
        id,
        name,
        image,
        classify,
        price,
        poepleCount,
        mealDetail,
        putaway,
        tableware,
        clamp,
        count,
        type,
      } = this.meal;
      tableware += parseInt(this.additional.tableware);
      classify = classify.map((item) => {
        // console.log(11111,item)
        Reflect.deleteProperty(item,"Beyond");
        return item;
      });
      clamp += parseInt(this.additional.clamp);
      orderDetails.push({
        id,
        name,
        image,
        classify,
        price,
        poepleCount,
        mealDetail,
        putaway,
        tableware,
        clamp,
        count,
        type,
      });
      this.$set(this.add, "orderDetails", orderDetails);
      this.$set(this.add, "orderAmount", orderPrice);

      this.getMutate(addOrder, { add: this.add }).then((res) => {
        // console.log(res);
      });
    },
  },
};
</script>
<style scoped>
.pay {
  padding: 3rem 1rem;
}
.pay > h4 {
  text-align: center;
}
.pay > h5 {
  text-align: center;
}
.pay > .select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  box-shadow: 0 5px 10px hsl(0deg 0% 43% / 30%);
  padding: 0.5rem;
  font-weight: 700;
  margin: 1rem 0;
  cursor: pointer;
  border-radius: 0.25rem;
}
.pay > .select h4 {
  margin: 0 0rem;
}
.pay > .select h6 {
  text-align: left;
}
.pay > .select .box {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  margin: 0.6rem 0;
}
.pay > .select .box > img {
  margin: 0 0.25rem;
}
</style>
